// extracted by mini-css-extract-plugin
export var chip = "_hb-0";
export var filterDropdown = "_hb-5";
export var filterItem = "_hb-6";
export var icon = "_hb-1";
export var removeButton = "_hb-3";
export var removeIcon = "_hb-4";
export var separator = "_hb-2";